<template>
  <main class="main" role="main">
    <div class="main_con">
      <img
        class="img sheet_save"
        :src="require('@/assets/front/images/img_sheet_save.png')"
        alt=""
      />
      <div class="msg">
        <div>요청서가 저장되었습니다.</div>
        <button class="btn bo" @click="gotoShops">상담받으러 가기</button>
      </div>
    </div>
    <div class="btm_btn">
      <div class="btn_wrap">
        <button class="btn" @click="gotoMain">홈으로 이동하기</button>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    gotoMain() {
      this.$router.push({ name: 'Home' });
    },
    gotoShops() {
      this.$router.push({ name: 'Shop.List' });
    },
  },
};
</script>
